/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './wong-bakers-pain-score.reducer';

export const WongBakersPainScoreDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const wongBakersPainScoreEntity = useAppSelector(state => state.wongBakersPainScore.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="wongBakersPainScoreDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.wongBakersPainScore.detail.title">WongBakersPainScore</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.wongBakersPainScore.id">Id</Translate>
            </span>
          </dt>
          <dd>{wongBakersPainScoreEntity.id}</dd>
          <dt>
            <span id="reading">
              <Translate contentKey="tinyMedicRestApp.wongBakersPainScore.reading">Reading</Translate>
            </span>
          </dt>
          <dd>{wongBakersPainScoreEntity.reading}</dd>
          <dt>
            <span id="notes">
              <Translate contentKey="tinyMedicRestApp.wongBakersPainScore.notes">Notes</Translate>
            </span>
          </dt>
          <dd>{wongBakersPainScoreEntity.notes}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.wongBakersPainScore.active">Active</Translate>
            </span>
          </dt>
          <dd>{wongBakersPainScoreEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.wongBakersPainScore.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{wongBakersPainScoreEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.wongBakersPainScore.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{wongBakersPainScoreEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.wongBakersPainScore.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{wongBakersPainScoreEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.wongBakersPainScore.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{wongBakersPainScoreEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.wongBakersPainScore.patient">Patient</Translate>
          </dt>
          <dd>{wongBakersPainScoreEntity.patient ? wongBakersPainScoreEntity.patient.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/wong-bakers-pain-score" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/wong-bakers-pain-score/${wongBakersPainScoreEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default WongBakersPainScoreDetail;
